import { useEffect, useRef, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';

interface HistoryState {
  canGoBack: boolean;
  goBack: () => void;
}

const useCustomHistory = (): HistoryState => {
  const historyStack = useRef<string[]>([]);
  const [canGoBack, setCanGoBack] = useState(false);
  const history = useHistory();
  // Get current URL without the domain
  const getCurrentUrl = useCallback(() => {
    return `${window.location.pathname}${window.location.search}`;
  }, []);

  useEffect(() => {
    const storedStack = sessionStorage.getItem('history') ?? '[]';
    if (storedStack) {
      historyStack.current = JSON.parse(storedStack);
      setCanGoBack(historyStack.current.length > 1);
    }
  }, []);
  useEffect(() => {
    const handleLocationChange = () => {
      const currentUrl = getCurrentUrl();

      if (historyStack.current[historyStack.current.length - 1] !== currentUrl) {
        historyStack.current.push(currentUrl);
        setCanGoBack(historyStack.current.length > 1);
      }
    };

    // Initialize with current URL
    handleLocationChange();

    // Listen for popstate event (browser back/forward buttons)
    window.addEventListener('popstate', handleLocationChange);

    return () => {
      window.removeEventListener('popstate', handleLocationChange);
    };
  }, [getCurrentUrl]);

  const goBack = useCallback(() => {
    if (canGoBack) {
      historyStack.current.pop(); // Remove current URL
      history.goBack();
    }
  }, [canGoBack, history]);

  return {
    canGoBack,
    goBack,
  };
};

export default useCustomHistory;
